import { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import PasswordExpiryBanner from './PasswordExpiryBanner';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar onCollapse={setSidebarCollapsed} />
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-64'}`}>
        <TopBar />
        <PasswordExpiryBanner />
        <main className="p-6">{children}</main>
      </div>
    </div>
  );
}
